import {Injectable, Optional} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {CmsComponent} from '@kion/data-models';
import {HttpClient} from '@angular/common/http';
import {ApiConfig} from '../../../../../api-endpoint/src/lib/api.config';

interface IResponseItem {
  uid: string,
  uuid: string,
  typeCode: string,
  modifiedTime: string,
  name: string,
  container: string,
  node?: {
    container?: boolean,
    uid?: string,
    name?: string,
    links?: string,
    title?: string,
    uuid?: string,
    typeCode?: string,
  },
  external?: boolean,
  icon?: string,
  linkName?: string,
  url?: string,
  target?: boolean,
  linkRe?: {
    container?: boolean,
    uid?: string,
    external?: boolean,
    name?: string,
    icon?: string,
    uuid?: string,
    linkName?: string,
    url?: string,
    typeCode?: string,
    target?: boolean
  },
  links?: string,
  title?: string
}

interface ISearchResponse {
  component: IResponseItem[]
}

@Injectable({
  providedIn: 'root'
})
export class CmsComponentConnectors {

  private readonly _rootUrl: string;
  private readonly _baseSite: string;

  private route = '/cms/components';

  constructor(
    @Optional() apiConfig: ApiConfig,
    private http: HttpClient,
  ) {
    this._rootUrl = apiConfig.rootUrl;
    this._baseSite = apiConfig.baseSite;
  }

  private static transformFromApi(response: IResponseItem): CmsComponent {
    return {
      ...response,
      id: response.uid
    };
  }

  getAll(): Observable<CmsComponent[]> {
    return this.http.get<ISearchResponse>(this.getManyUrl()).pipe(
      map((response: ISearchResponse) => response.component.map(
        (responseItem: IResponseItem) => CmsComponentConnectors.transformFromApi(responseItem)
      )),
      catchError(error => {
        console.error('Load CmsComponent error', error);
        return throwError('CmsComponent could not be loaded!');
      })
    );
  }

  getByIds(componentIds: string[]): Observable<CmsComponent[]> {
    return this.http.get<ISearchResponse>(this.getManyUrl() + '?' + componentIds.map(component => 'componentIds=' + component).join('&'))
      .pipe(
        map((response: ISearchResponse) => response.component.map(
          (responseItem: IResponseItem) => CmsComponentConnectors.transformFromApi(responseItem)
        )),
        catchError(error => {
          console.error('Load CmsComponent error', error);
          return throwError(error);
        })
      )
  }

  protected getManyUrl() {
    return this._rootUrl + this._baseSite + this.route;
  }

  protected getOneUrl(id: string) {
    return this._rootUrl + this._baseSite + this.route + '/' + id;
  }
}
